module.exports = __webpack_public_path__ + "static/media/mail-to@3x.8ace5120.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/mail-to@3x.png
// module id = 1890
// module chunks = 0